import { Minus } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../../ricos-modals/modal-service-provider.js";
import { DropdownButton } from "./../../../_shared/dropdown-button.js";
import LineStylePanel from "../modals/LineStylePanel.js";
import { dividerStyleData } from "./dividerButtonsData.js";
const DividerStyleButton = ({ toolbarItem, dataHook, id }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const SelectedStyleIcon = dividerStyleData.find(({ commandKey }) => commandKey === toolbarItem?.attributes.nodeStyle)?.icon || Minus;
  const onClick = () => {
    modalService.isModalOpen(id) ? modalService.closeModal(id) : modalService.openModal({
      Component: LineStylePanel,
      id,
      componentProps: {
        modalId: id,
        toolbarItem
      },
      layout: isMobile ? "drawer" : "floating",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      ref: setReferenceElement,
      icon: SelectedStyleIcon,
      tooltip: t("DividerPlugin_SelectType_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DividerStyleButton
};
//# sourceMappingURL=DividerStyleButton.js.map
